import { http, HttpResponse, delay } from 'msw';

import { Champion as ChampionDto } from '@electricjs/core_entity-client';

import {
  MOCK_APP_SLUG_WITH_RESTRICTED_CHAMPION,
  organizationApplicationChampionsList,
} from '@/mocks/data/organizationApplicationChampionData';
import { RESTRICTED_CHAMPION_EMPLOYEE_ID } from '@/mocks/data/requestData';

export const organizationApplicationChampionHandlers = [
  http.get(
    `*/v1/organizations/:organizationId/organization_applications/:applicationKey/champions`,
    async () => {
      await delay(200);
      return HttpResponse.json(
        { total: 3, results: organizationApplicationChampionsList },
        { status: 200 }
      );
    }
  ),
  http.post(
    `*/v1/organizations/:organizationId/organization_applications/:applicationKey/champions`,
    async () => {
      const orgAppChampion = {
        id: 'champion-1',
        employee_id: 'employee-1',
      };
      organizationApplicationChampionsList.push(orgAppChampion);
      await delay(200);
      return HttpResponse.json(orgAppChampion, { status: 201 });
    }
  ),
  // Bulk lookup used by composed application-champions queries on the employee
  // profile Applications tab and the Applications table. Apps have no champions
  // by default; one app gets a visible and a hidden champion (outside the
  // user's divisions: absent from the mock employee list and map) so Restricted
  // shows in the table and the ownership selector.
  http.post(
    `*/v1/organizations/:organizationId/organization_applications/champions/bulk`,
    async ({ request }) => {
      const body = (await request.json()) as { application_keys?: string[] };
      const organization_application_champions: Record<string, ChampionDto[]> =
        {};
      (body.application_keys ?? []).forEach(appKey => {
        organization_application_champions[appKey] =
          appKey === MOCK_APP_SLUG_WITH_RESTRICTED_CHAMPION
            ? [
                {
                  id: 'app-champion-visible',
                  employee_id: 'simple-employee-id',
                },
                {
                  id: 'app-champion-restricted',
                  employee_id: RESTRICTED_CHAMPION_EMPLOYEE_ID,
                },
              ]
            : [];
      });
      await delay(200);
      return HttpResponse.json(
        { organization_application_champions },
        { status: 200 }
      );
    }
  ),
  http.delete(
    `*/v1/organizations/:id/organization_applications/:applicationKey/champions/:employeeId`,
    async ({ params }) => {
      const { employeeId } = params;
      organizationApplicationChampionsList.splice(
        organizationApplicationChampionsList.findIndex(
          a => a.employee_id === employeeId
        ),
        1
      );
      await delay(200);
      return new HttpResponse(null, { status: 204 });
    }
  ),
];
